import React, { useState, useCallback } from 'react'
import TransferList from "../../../common/components/widgets/TransferList";
import Button from "@material-ui/core/Button/index";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions/index";
import DialogContent from "@material-ui/core/DialogContent/index";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import SimpleSearch from '../../../common/components/data-table/SimpleSearch';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import './TransferUsersToGroup.css';
import SearchUsers from '../SearchUsers';
// import {GET_USER_GROUP} from '../../../components/userGroup/queries' // TODO: Replaced with REST hook
import { useUserGroup } from '../../../hooks/useUserGroup';
import { useUsers } from '../../../hooks/useUsers';
import { useSetUsersForGroup } from '../../../hooks/useSetUsersForGroup';

const CustomButton = withStyles((theme) => ({
  root: {
    width: 115,
    fontSize: 16,
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E91E63',
    border: 'none',
    '&:hover': {
      backgroundColor: '#FF4282',
    },
    '&:active': {
      backgroundColor: '#FF4282',
    },
    '&:focus': {
      border: 'none'
    },
  },
}))(Button);


// TODO: GET_USERS replaced with REST hook useUsers
/*
const GET_USERS = gql`
    query users($userGroup: String){
        users(userGroup: $userGroup){
        records{
            _id
            sigla
            name
            surname
        }
        pages
        totalCount
        }
    }
`;
*/

// TODO: Replaced GraphQL mutation with REST hook
/*
const SET_USER_FOR_GROUP = gql `
    mutation setUsersForUserGroup($id: String, $input: [Users]){
      setUsersForUserGroup(id: $id, input: $input)
}
`;
*/

function TransferUsersToGroup (props) {
    const open = props.open;
    const userGroupId = props.userGroupId
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [userGroup, setUsergroup] = useState([]);
    // const [setUserForGroup, mutation ] = useMutation(SET_USER_FOR_GROUP); // Replaced with REST hook
    const [nameSearch, setNameSearch] = useState(null);
    const handleClose = props.handleClose;
    
    // Use REST hook instead of GraphQL
    const { data: userGroupData } = useUserGroup(userGroupId);
    
    // Set users for group mutation
    const setUsersForGroupMutation = useSetUsersForGroup();
    
    // Update userGroup name when data changes
    React.useEffect(() => {
      if (userGroupData?.userGroup?.name) {
        setUsergroup(userGroupData.userGroup.name);
      }
    }, [userGroupData]);
    
    // Use REST hook instead of GraphQL for fetching users in group
    const { data: usersData } = useUsers({
      userGroup: userGroupId,
      page: null,
      enabled: !!userGroupId // Only fetch if we have a userGroupId
    });
    
    // Update right side (users in group) when data changes
    React.useEffect(() => {
      if (usersData?.users?.records) {
        const usersArray = usersData.users.records.map((user) => {
          return {
            id: user._id, 
            value: user.sigla + " " + user.name + " " + user.surname
          }
        });
        setRight(usersArray);
      }
    }, [usersData]);
    
    // TODO: Removed GraphQL GET_USERS query, replaced with REST hook useUsers above
    /*
    const getUsersQueryResult = useQuery(GET_USERS,{
      variables: {
          userGroup: userGroupId,
          },
      fetchPolicy: "network-only",
      client: client,
      notifyOnNetworkStatusChange: true,
      onError: () => { console.log("error getting users")},
      onCompleted: (data) => {
                     if(data!==getUsersQueryResult.previousData) {
                      const  usersArray =  data.users.records.map((user) => {
                        return {id: user._id, value: user.sigla+ " " + user.name + " " + user.surname}
                      });
                      setRight(usersArray);
                    }

    }});
    */

    // TODO: Removed GraphQL GET_USER_GROUP query, replaced with REST hook useUserGroup above
    /*
    const {
      // loading,
      // error,
      // data,
      previousData,
      //variables
    } = useQuery(GET_USER_GROUP,{
      variables: {
        id: userGroupId,
      },
      fetchPolicy: "network-only",
      client: client,
      notifyOnNetworkStatusChange: true,
      onError: () => { console.log("error getting user group")},
      onCompleted: (data) => {
        if(data!==previousData) {
          setUsergroup(data.userGroup.name);
        }
      }
    });
    */

    function handleChange(left,right) {
        setLeft(left);
        setRight(right);
    }

  function save(input){
    setUsersForGroupMutation.mutate({
      userGroupId: input.userGroupId,
      users: input.users.map(record => ({
        id: record.id,
      }))
    }, {
      onSuccess: () => {
        handleClose(); // Close dialog on success
      },
      onError: (error) => {
        
      }
    });
  }

  const handleSearchResult = useCallback((data) => {
    if(data===undefined) return;
    const users = data.usersNotInUserGroup?.records;
    if(users===undefined) return;
    const usersArray = users.map((user) => {
      return {id: user._id,  value: (user.sigla || '' )+ " " + user.name + " " + (user.surname || '')}
    });
    setLeft(usersArray);
  }, []);

  function _keyPress(e){
    if (e.keyCode === 13) {
      setNameSearch(e.target.value);
    }
  }


  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="tug-dialog"
      >
        <MuiDialogTitle className="tug-dialog__title" disableTypography id="alert-dialog-title">
          <Typography variant="h6" component="h2">{"Assign Users to group"}</Typography>
          <IconButton aria-label="close" className="tug-dialog__close" onClick={handleClose}>
            <CloseIcon style={{ fontSize: 28 }}/>
          </IconButton>
        </MuiDialogTitle>

        <DialogContent className="tug-dialog__content">
          <SimpleSearch keyPress={_keyPress} />
          <TransferList
            left={left}
            right={right}
            rightTitle={"User group: "+userGroup}
            leftTitle="Users"
            handleChange={handleChange}
          ></TransferList>
        </DialogContent>
        <SearchUsers name={nameSearch} userGroupId={userGroupId} handleSearchResult={handleSearchResult} />
        <DialogActions className="tug-dialog__footer">
          <CustomButton
            variant="contained"
            size="medium"
            className="tug-dialog__button"
            onClick={e => {
                save({ userGroupId: userGroupId, users: right });
            }}
            autoFocus
          >
            Save
          </CustomButton>
        </DialogActions>

      </Dialog>
    </div>
  )
}

export default TransferUsersToGroup
